import Button from "../../../components/elements/Button/Button";
import {useIntl} from "react-intl";
import {useEffect, useState} from "react";
import axios from "axios";
import errorParser from "../../../components/ErrorParser/ErrorParser";
import {useNavigate} from "react-router-dom";
import Paginate from "../../../components/elements/Paginate/Paginate";
import LoadingComp from "../../../components/elements/LoadingComp/LoadingComp";

export default function SimsDeclarations() {

    const intl = useIntl();
    const navigate = useNavigate()
    const jwt = localStorage.getItem('jwt')

    const [items, setItems] = useState([])

    const [loading, setLoading] = useState(true)
    const [page, setPage] = useState(1)
    const [totalItems, setTotalItems] = useState(0)

    useEffect(() => {
        getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page])

    const getData = async () => {
        axios.get(process.env.REACT_APP_API + '/smartlab-sims-declarations/list/' + page, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                setItems(response.data.items ?? [])
                setTotalItems(response.data.total ?? 0)
                setLoading(false)
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }


    const deleteItem = async (id) => {
        axios.delete(process.env.REACT_APP_API + '/smartlab-sims-declarations/' + id, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                if (response.data.status === 1) {
                    getData()
                }
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }

    if (loading) {
        return <LoadingComp/>
    }

    return (
        <div className="container">

            <div className={"row"}>
                <div className={"col-12"}>
                    <h1 className={"container-title"}>Declarații SMIS</h1>
                </div>

                <div className={"col-12 pb-4"}>

                <div className="card">

            <div className={"header d-flex"}>
                <Button
                    className={"btn-primary d-flex align-items-center ms-auto"}
                    icon={"fa-solid fa-plus"}
                    value={"Adaugă"}
                    onClick={() => navigate('/sims/add')}
                />
            </div>


            {
                items.length === 0 ?
                    <div className={"content"}>

                        <div className={"alert alert-warning"}>Momentan nu aveți nici un proiect adăugat!</div>
                    </div>
                    :
                    <div className={"content p-0"}>
                        <div className={"table mb-1"}>

                            <div className={"table-head"}>
                                <div className={"row"}>
                                    <div className={"col-1 table-td"}>Nr</div>
                                    <div className={"col-6 table-td"}>Instituție</div>
                                    <div className={"col-3 table-td"}>Cod proiect</div>
                                    <div className={"col-2 table-td"}></div>
                                </div>
                            </div>

                            <div className={"table-body"}>
                                {
                                    items.map((item, i) => (
                                        <div className={"table-row"} key={i}>
                                            <div className={"row"}>
                                                <div
                                                    className={"col-1 table-td"}>
                                                    {i + 1 + (page-1) * 10}
                                                </div>
                                                <div
                                                    className={"col-6 table-td"}>
                                                    {item.client.company_title}
                                                </div>
                                                <div
                                                    className={"col-3 table-td"}>
                                                    {item.project_code}

                                                </div>
                                                <div className={"col-2 table-td"}>
                                                    <Button
                                                        className={"btn-light btn-edit ms-auto"}
                                                        icon={"fa-solid fa-pen"}
                                                        onClick={() => navigate('/sims/' + item.id)}
                                                    />
                                                    <Button
                                                        className={"btn-light btn-edit"}
                                                        icon={"fa-solid fa-file"}
                                                        onClick={() => navigate('/sims/download/' + item.id)}
                                                    />
                                                    <Button
                                                        className={"btn-light btn-delete"}
                                                        icon={"fa-solid fa-trash"}
                                                        onClick={() => deleteItem(item.id)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
            }

            <div className={"footer d-flex justify-content-center"}>
                <Paginate
                    page={page}
                    setPage={setPage}
                    totalItems={totalItems}
                />
            </div>
        </div>
                </div>
            </div>
        </div>
    );
}

